import { createContext, useState } from "react";
import { toast } from "react-hot-toast";
import clienteAxios from "../config/clienteAxios";

const CalculatorContext = createContext();

const CalculatorProvider = ({ children }) => {
  const [calculator, setCalculator] = useState(null);

  const getAllCalculator = async () => {
    try {
      const { data } = await clienteAxios("/calculator");
      const [firstCalculator] = data.allCalculator;
      setCalculator(firstCalculator);
    } catch (error) {
      toast.error('Error al obtener los datos de la calculadora')
    }
  };

  const editCalculator = async (calculatorEdit) => {
    try {
      const { data } = await clienteAxios.put(`/calculator`, calculatorEdit);
      setCalculator(calculatorEdit)
      toast.success("Se actualizó sección Calculadora");
    } catch (error) {
      toast.error("Error al actualizar sección Calculadora");
    }
  };

  return (
    <CalculatorContext.Provider
      value={{
        editCalculator,
        calculator,
        getAllCalculator
      }}
    >
      {children}
    </CalculatorContext.Provider>
  );
};

export { CalculatorProvider };

export default CalculatorContext;